var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import axios from "axios";
import { getAppRoot } from "@/onload/loadConfig";
import { rethrowSimple } from "@/utils/simple-error";
export function setAttributes(datasetId, settings, operation) {
    return __awaiter(this, void 0, void 0, function* () {
        const payload = Object.assign({ dataset_id: datasetId, operation: operation }, settings);
        const url = `${getAppRoot()}dataset/set_edit`;
        try {
            const { data } = yield axios.put(url, payload);
            return data;
        }
        catch (e) {
            rethrowSimple(e);
        }
    });
}
